"use strict";

var _regeneratorRuntime = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFlags = void 0;
/**
 * A function that does something
 * @public
 */

function fetchFlags(_x) {
  return _fetchFlags.apply(this, arguments);
}

function _fetchFlags() {
  _fetchFlags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
    var featureFlagsUrl, headers, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            featureFlagsUrl = options.featureFlagsUrl || "https://feature-flags.decentraland.org";
            headers = new Headers();
            if (options.debug) headers.set("X-Debug", "true");
            if (typeof options.userId === "string" && options.userId.length) headers.set("X-Address-Hash", options.userId);
            _context.next = 6;
            return fetch(new URL(options.applicationName + ".json", featureFlagsUrl).toString(), {
              method: "get",
              mode: "cors",
              credentials: "include",
              headers: headers
            });

          case 6:
            res = _context.sent;

            if (res.ok) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", {
              flags: {},
              variants: {},
              error: new Error("Request to features server failed")
            });

          case 9:
            _context.prev = 9;
            _context.next = 12;
            return res.json();

          case 12:
            return _context.abrupt("return", _context.sent);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](9);
            return _context.abrupt("return", {
              flags: {},
              variants: {},
              error: _context.t0
            });

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 15]]);
  }));
  return _fetchFlags.apply(this, arguments);
}

exports.fetchFlags = fetchFlags;